// /src/components/simulator/ModelComparisonSelector.jsx
import React, { useState } from 'react';
import { Select } from 'antd';

const { Option } = Select;

const ModelComparisonSelector = ({ availableModels, selectedModels, setSelectedModels }) => {
  const [internalModels, setInternalModels] = useState(selectedModels);

  const handleChange = (value) => {
    // Always keep the first model from selectedModels
    const fixedFirstModel = selectedModels[0];

    // Filter out the fixed model accidentally removed
    const updatedModels = [fixedFirstModel, ...value.filter(v => v !== fixedFirstModel)];

    // Limit to max 3 models
    const finalModels = updatedModels.slice(0, 5);

    setInternalModels(finalModels);
    setSelectedModels(finalModels);
  };

  return (
    <div className="bg-white p-6 md:p-8 rounded-lg shadow-md max-w-5xl mx-auto text-gray-800 space-y-6 leading-relaxed">
      <h2 className="text-lg font-semibold mb-2 text-center text-blue-700">
        Compare Models (max 5)
      </h2>
      <Select
        mode="multiple"
        allowClear={false}
        style={{ width: '100%' }}
        placeholder="Select models to compare"
        value={internalModels}
        onChange={handleChange}
      >
        {availableModels.map((model) => (
          <Option key={model} value={model}>
            {model}
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default ModelComparisonSelector;
